import { MenuOption, Option } from '../types';
import { MenuOptionSorter, OptionConfig, Sorter } from './types';

export const getOptionsMinusExisting = (options: Option[] | undefined, existing: MenuOption[]) => {
  if (!options) {
    return [];
  }

  const ids = existing.map((option) => option.option.id);
  return options.filter((option) => !ids.includes(option.id));
};

export const isCarouselConfig = (config: OptionConfig): boolean => {
  return config.widget === 'carousel';
};

export const getSortingFunction = (sorter: string | undefined): MenuOptionSorter | null => {
  switch (sorter) {
    case Sorter.Mixers:
      return compareMixers;
    default:
      return null;
  }
};

const NEAT = 'neat';
const ON_THE_ROCKS = 'on the rocks';

export const compareMixers = (lhs, rhs) => {
  const loweredLhs = lhs.option.name.toLowerCase();
  const loweredRhs = rhs.option.name.toLowerCase();

  if (loweredLhs === NEAT) {
    return -1;
  } else if (loweredRhs === NEAT) {
    return 1;
  }

  if (loweredLhs === ON_THE_ROCKS) {
    return -1;
  } else if (loweredRhs === ON_THE_ROCKS) {
    return 1;
  }

  return loweredLhs < loweredRhs ? -1 : loweredLhs === loweredRhs ? 0 : 1;
};
